"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PriceContainer_1 = require("./PriceContainer");
exports.default = PriceContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/PriceContainer/index.js
// module id = 450
// module chunks = 8